export enum SupportedInsightsAsset {
  BTC = 'BTC',
  ETH = 'ETH',
  XAU = 'XAU',
  SOL = 'SOL',
  JITOSOL = 'JITOSOL',
}

export const deribitAssetMatching: Record<SupportedInsightsAsset, string> = {
  [SupportedInsightsAsset.BTC]: 'BTC',
  [SupportedInsightsAsset.ETH]: 'ETH',
  [SupportedInsightsAsset.XAU]: 'XAU',
  [SupportedInsightsAsset.SOL]: 'SOL_USDC',
  [SupportedInsightsAsset.JITOSOL]: 'JITOSOL',
};
